import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const OuterWrapperBackground = styled.div`
    background: #f5f5f5 !important;
}`;

export const PaddingDiv = styled.div`
  box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 20%);
  background-color: white;
  padding: 1.3rem;
}`;

export const FlexRowHeader = styled.div`
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#008395"};
  display: flex;
  justify-content: space-between;
  padding: 10px;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px 5px 0px 0px;
`;

export const Title = styled.h3`
  color: white !important;
  text-align: left;
  width: 100%;
  font-family: "Lato";
  font-size: 20px;
  line-height: 20px;
  margin: 0;
  font-weight: normal;
  width: auto;
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "0px")};
`;

export const QuoteInfoAndConditionsInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: ${(props) => props.padding ?? "20px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "15px"};
  font-weight: normal;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const ErrorDiv = styled.div`
  height: 35px;
  border: solid 1px red;
  padding: 7px;
`;

export const OuterDiv = styled.div`
  margin-top: 1.2rem;
`;

export const GridItem = styled.div`
  border: 1px solid rgba(10, 73, 134, 0.3);
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: #474747;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: 10px;
  font-size: ${(props) => props.fontSize ?? "16px"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "italic"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;

export const ExchangeInputStyles = {
  padding: "7px 5px 7px 10px",
  border: "1px solid #f08046",
};
